module.exports = __webpack_public_path__ + "static/img/me-img1.e0222be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/me-img1.png
// module id = xDUh
// module chunks = 0